import { SnailyError } from './SnailyError'

export class HandledError extends SnailyError {
	constructor(message: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'HandledError'
		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, HandledError)
		}
	}
}
